<template>
  <div class="navMenu">
    <!-- <router-link :to="item.path" v-for="item in allRoutes" :key="item.path">
      <p :class="['menu-item', toPath == item.path ? 'menuActive' : '']">
        {{ item.meta.title }}
      </p>
    </router-link> -->
    <el-menu
      :default-active="toPath"
      mode="horizontal"
      @select="handleSelect"
      active-text-color="#0073D3"
      text-color="#333333"
    >
      <template v-for="item in allRoutes">
        <el-menu-item v-if="!item.children" :key="item.path" :index="item.path">
          {{ item.meta.title }}
        </el-menu-item>
        <el-submenu v-else :key="item.path" :index="item.path">
          <template slot="title">{{ item.meta.title }}</template>
          <el-menu-item
            v-for="(val, i) in item.children"
            :key="i"
            :index="val.path"
          >
            {{ val.meta.title }}
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
    <div class="userInfo" v-if="JSON.stringify(userInfo) !== '{}'">
      <el-popover
        placement="bottom"
        title=""
        width="200"
        trigger="hover"
        content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
      >
        <div style="font-size: 16px">
          <span>您好：</span><span>{{ userInfo.userName }}</span>
        </div>
        <div style="font-size: 16px">
          <span>手机号：</span
          ><span>{{ maskPhoneNumber(userInfo.phonenumber) }}</span>
        </div>
        <div style="text-align: right; margin: 10px 0">
          <el-button type="danger" @click.stop="loginOutClick"
            ><span style="color: #fff">退出登录</span></el-button
          >
        </div>
        <img v-if="!userInfo.avatar" slot="reference" :src="avatar" alt="" />
        <img v-else slot="reference" :src="getImageUrl(userInfo.avatar)" alt="" />
      </el-popover>
    </div>
  </div>
</template>

<script>
import cookies from "vue-cookies";
import { mapMutations, mapState } from "vuex";
import { getImageUrl } from "@/utils/tool";
export default {
  name: "navMenu",
  data() {
    return {
      allRoutes: [],
      toPath: "",
      // avatar: "http://gips2.baidu.com/it/u=1674525583,3037683813&fm=3028&app=3028&f=JPEG&fmt=auto?w=1024&h=1024"
      avatar: require("../../../assets/images/profile.png"),
    };
  },
  computed: {
    ...mapState("user", ["userInfo", "token"]),
  },
  watch: {
    $route: {
      handler(to) {
        this.toPath = to.name;
      },
      immediate: true,
    },
    userInfo: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") {
          const routes = this.$router.options.routes[0];
          const arr = routes.children.filter((item) => item.meta.hidden);
          const filterArr = arr.filter(
            (item) => item.meta.title !== "用户登录"
          );
          this.allRoutes = filterArr;
        } else {
          const routes = this.$router.options.routes[0];
          const arr = routes.children.filter((item) => item.meta.hidden);
          const filterArr = arr.map((item) => {
            if (item.meta.title === "进入园区") {
              item.meta.title = "进入服务";
            }
            return item;
          });
          this.allRoutes = filterArr;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.routerTitles();
  },

  methods: {
    getImageUrl,
    ...mapMutations("user", ["CLEAR_USERINFO"]),
    routerTitles() {
      // const routes = this.$router.options.routes[0];
      // this.allRoutes = routes.children.filter(item => item.meta.hidden);
      // const routes = this.$router.getRoutes();
      // this.allRoutes = routes.filter((item) => item.meta.hidden);
    },
    //手机号码过滤
    maskPhoneNumber(phoneNumber) {
      if (!phoneNumber) return "暂无";
      const firstDigit = phoneNumber[0];
      const lastFourDigits = phoneNumber.slice(-4);
      const middle = "*".repeat(phoneNumber.length - 5);
      return `${firstDigit}${middle}${lastFourDigits}`;
    },
    handleSelect(url, row) {
      this.$router.push({ path: url });
    },
    //退出按钮点击事件
    loginOutClick() {
      this.$message.success("退出成功");
      this.CLEAR_USERINFO();
      this.$router.push("home");
    },
  },
};
</script>

<style lang="scss" scoped>
.navMenu {
  @include inheritWH(65%);
  @include crosswise(flex-end);
  align-items: center;

  .el-menu.el-menu--horizontal {
    border: none;

    .el-dropdown-menu__item,
    .el-menu-item {
      font-size: 16px;
    }

    ::v-deep .el-submenu__title {
      font-size: 16px;
    }
  }

  .userInfo {
    width: 35px;
    height: 35px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      border-radius: 100%;
    }
  }

  // .menu-item {
  //   font-size: 15px;
  //   margin-right: 50px;
  // }

  // .router-link-active>.menu-item,
  // .menuActive {
  //   color: $menu-active-color;
  //   position: relative;
  // }

  // .router-link-active>.menu-item::after,
  // .menuActive::after {
  //   content: "";
  //   position: absolute;
  //   bottom: -15px;
  //   left: -2px;
  //   width: 110%;
  //   height: 2px;
  //   background-color: $menu-active-color;
  // }
}
</style>
